import { Timestamp } from 'firebase/firestore';

import { UserType } from '../auth/roles';

export const BROKEN_PATIENT_REPORT_ACTIONS = {
  BROKEN_PATIENT_DATA_DETECTED: 'BROKEN_PATIENT_DATA_DETECTED',
  AUTH_PATIENT_MISSING_FIRESTORE_DOC: 'AUTH_PATIENT_MISSING_FIRESTORE_DOC',
} as const;

export type BrokenPatientReportAction =
  (typeof BROKEN_PATIENT_REPORT_ACTIONS)[keyof typeof BROKEN_PATIENT_REPORT_ACTIONS];

export type DiagnosticsDoc = {
  brokenPatientReport?: BrokenPatientReport;
  userId: string;
};

export type BrokenPatientReport = {
  createdAt?: Timestamp;
  status: 'STARTED' | 'RESOLVED';
  action: BrokenPatientReportAction;
  resolvedByUid?: string;
  resolvedAt?: Timestamp;
  resolvedByUserType?: UserType;
};
